(ns hypnos.backoffice.tile.field.anatomy-facial-hair
  "Field for facial hair.."
  (:require [hypnos.i18n :refer [tr]]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; field

(defn field
  ([state]
   (field state {:disabled false}))
  ([state {:keys [disabled] :or {disabled false}}]
   [:div.field.has-check.is-horizontal
    [:div.field-label.is-normal
     [:label.label (str (tr :ui.label/facial-hair))]]
    [:div.field-body
     [:div.field.is-grouped-multiline.is-grouped
      [:div.control
       [:label.b-radio.radio
        [:input.input {:type      :radio
                       :name      "facial-hair"
                       :disabled  disabled
                       :checked   (true? (get-in @state [:anatomy :anatomy/facial-hair?]))
                       :on-change (fn [e]
                                    (let [new-value (when (-> e .-target .-checked) true)]
                                      (swap! state assoc-in
                                             [:anatomy :anatomy/facial-hair?]
                                             new-value)))}]
        [:span.check.is-info]
        [:span.control-label (tr :ui.label/yes)]]]
      [:div.control
       [:label.b-radio.radio
        [:input.input {:type      :radio
                       :name      "facial-hair"
                       :disabled  disabled
                       :checked   (when (not (nil? (get-in @state [:anatomy :anatomy/facial-hair?])))
                                    (false? (get-in @state [:anatomy :anatomy/facial-hair?])))
                       :on-change (fn [e]
                                    (let [new-value (when (-> e .-target .-checked) false)]
                                      (swap! state assoc-in
                                             [:anatomy :anatomy/facial-hair?]
                                             new-value)))}]
        [:span.check.is-info]
        [:span.control-label (tr :ui.label/no)]]]]]]))
